import React, { Suspense, useEffect, useState } from 'react';
import MainHeader from '../../partial/MainHeader';
import DailyNews from '../News/News';
import { getApi } from '../../services/apiService';
import { apiConstant } from '../../services/apiConfig';
import MainFooter from '../../partial/Footer';
import { commonStrings } from '../../services/stringConstant';
import { Category } from '../../types/category.types';
import { toast } from 'react-toastify';
import ShimmerEffect from '../ShimmerEffect';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [commonData, setCommonData] = useState<Category[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        getApi(apiConstant.sectionOne).then((res) => {
            setCommonData(res);
            setIsLoading(false);
        }).catch((e) => {
            console.log('====================================');
            console.log(e);
            console.log('====================================');
            setIsLoading(false);
        });
    }, []);

    return (
        <>
            <Suspense fallback={
                <div className="w-full">
                    <div className="sticky top-0 z-50 bg-white">
                        <MainHeader />
                    </div>
                    <div className="container mx-auto p-4">
                        <ShimmerEffect type="text" count={3} />
                    </div>
                </div>
            }>
            <div className="sticky top-0 z-50 bg-white">
                <MainHeader />
            </div>
                {isLoading ? (
                    <div className="container mx-auto p-4">
                        <ShimmerEffect type="text" count={3} />
                    </div>
                ) : (
                    <DailyNews data={commonData && commonData.find((item) => item.categoryName === commonStrings.NEWS_UPDATE)} />
                )}
                <div className='p-2 mt-3'>
                    {children}
                </div>
                <MainFooter />
            </Suspense>
        </>
    );
};

export default Layout;
